import StoresManagerVue from '@/views/sa/stores-manager/stores-manager.vue';

const basePath = '/sa/stores-manager';
const role = 'sa'; // 角色身份

export const SA_STORES_MANAGER_INDEX = 'sa-stores-manager-index';
export const SA_STORES_MANAGER_EDIT_SA = 'sa-sotres-manager-edit-sa';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: StoresManagerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_STORES_MANAGER_INDEX,
      component: () => import(
        /* webpackChunkName: "stores-manager" */
        `@/views/${role}/stores-manager/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/editSa/:id`,
      name: SA_STORES_MANAGER_EDIT_SA,
      props: true,
      component: () => import(
        /* webpackChunkName: "stores-manager-edit-sa" */
        `@/views/${role}/stores-manager/editSa.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
